import { render, staticRenderFns } from "./game-smartsoft.vue?vue&type=template&id=81e97632&scoped=true"
import script from "./game-smartsoft.vue?vue&type=script&lang=js"
export * from "./game-smartsoft.vue?vue&type=script&lang=js"
import style0 from "./game-smartsoft.vue?vue&type=style&index=0&id=81e97632&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e97632",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-smartsoft.vue
// module id = UsLy
// module chunks = 0